import { create } from 'zustand';

/** What the active page hands the header search field. */
export interface HeaderSearchBinding {
  /** Current committed value (the page's URL param is the source of truth). */
  value: string;
  /** Page-specific placeholder, e.g. "Enter the full order number". */
  placeholder: string;
  /** Commit a new (trimmed) value; empty string clears the search. */
  onChange: (value: string) => void;
}

interface HeaderSearchState {
  /** Identity of the page that registered the binding. */
  owner: symbol | null;
  binding: HeaderSearchBinding | null;
  register: (owner: symbol, binding: HeaderSearchBinding) => void;
  /** Clears the binding only if `owner` still holds it (route-swap safe). */
  release: (owner: symbol) => void;
}

/**
 * Ephemeral UI state: which page currently drives the header search. The
 * searched value itself still lives in the page's URL params — this store only
 * brokers the page ↔ header handoff.
 */
export const useHeaderSearchStore = create<HeaderSearchState>((set) => ({
  owner: null,
  binding: null,
  register: (owner, binding) => set({ owner, binding }),
  release: (owner) =>
    set((state) => (state.owner === owner ? { owner: null, binding: null } : state)),
}));
